export const locale = {
  GLOBAL: {
    Title: "بيامك لاند",
    PostalCode: "الرمز البريدي",
    postalCodes: "الرموز البريدية",
    selectedPostalCodes: "الرموز البريدية المختارة",
    MciNumberCount: "عدد هواتف همراه أول",
    MtuNumberCount: "عدد هواتف إيرانسل",
    TotalCount: "العدد الكلي",
    Coefficient: "المعامل",
    Back: "رجوع",
  },
  ERRORS: {
    PhoneIsNotValid: "الرقم اللي دخلته مو صحيح: مثال 09101234567",
    InvalidNumber: "العدد اللي دخلته مو صحيح",
    NoSelectedLineNumber: "اختار خط الإرسال يالله",
    EmptyText: "اكتب النص يالله ما يصير فاضي",
    UnknownError: "فيه خطأ ما ندري عنه",
    TryAgain: "جرب مرة ثانية بعد شوي",
    NoAccountCharge: "رصيدك ما يكفي",
    NoAccess: "ما عندك صلاحية",
    PleasebyeAPlane: "اشتر باقة يالله",
    PleaseChargeYourAccount: "شحن حسابك بسرعة",
    AccessDenied: "ممنوع الدخول",
    AccessDeniedDescription: "لو تبي معلومات زيادة كلمنا على الدعم",
    Error: "خطأ",
    InvalidText: "النص مو زين",
    InvalidTextContainsLink: "بس الخطوط الخدمية تقدر تحط لينك",
  },
  INFOS: {
    SuccessSentSms: "الرسالة طلعت تمام إن شاء الله",
    SmsRequestInQueue: "رسالتك بتطلع بعد ما المدير يوافق",
    SendData: "بيانات الإرسال",
    CheckData: "شوف اللي تحت وأكد عليه",
  },
  TOBE: {
    to: "لـ ",
    from: "من ",
  },
  FORMS: {
    DestinationPhone: "رقم المستلم",
    TestDestinationPhone: "رقم التجربة",
    SourceNumber: "رقم المرسل",
    Text: "النص",
    CharCount: "عدد الحروف",
    FarsiCharCount: "عدد الحروف الفارسية",
    EnglishCharCount: "عدد الحروف الإنجليزية",
    Send: "إرسال",
    SendTime: "وقت الإرسال",
    SendTest: "إرسال تجريبي",
    SendToTestNumber: "إرسال للرقم التجريبي",
    SmsCount: "عدد الرسايل",
    SmsLang: "لغة الرسالة",
    Add: "ضيف",
    FromFile: "ضيف من ملف",
    TestNumber: "الرقم التجريبي",
    Test: "تجربة",
    ServiceRelated: "خدماتي",
    Price: "السعر",
    NumbersCount: "عدد الأرقام",
    NumbersCountToSend: "عدد اللي بيوصلهم الرسايل",
    Search: "دور",
    Title: "العنوان",
    RequestTime: "وقت الطلب",
    RequestInformation: "معلومات الطلب",
    CreateNewPhoneBook: "افتح دفتر تلفون جديد",
  },
  BUTTONS: {
    OK: "تمام",
    AccountCharge: "شحن الحساب",
    Reports: "التقارير",
    RemoveAll: "امسح الكل",
    BuyAPlane: "اشتر باقة",
    Accept: "أوكي",
    Reject: "لا",
    Yes: "إيه",
    No: "لا",
    Create: "خلّق",
    New: "جديد",
    Save: "حفظ",
    Delete: "امسح",
    More: "زود",
    TryAgain: "جرب مرة ثانية",
    Close: "سكّر",
    RollBack: {
      back: "ارجع للي قبل",
      goToMainUser: "ارجع للحساب الرئيسي",
      CurrentUser: "الحساب الحالي",
    },
  },
  DIALOGS: {
    Waiting: "استنى شوي",
    RejectItQuestion: "ترفضه؟",
    AcceptItQuestion: "توافق؟",
    Rejected: "رفضناه",
    Accepted: "وافقنا",
    Error: "خطأ",
  },
  CONFIRM: {
    Delete: "متأكد تبي تمسحه؟",
    DeleteA: "متأكد تبي تمسح {a}؟",
    DeleteALL: "متأكد تبي تمسح الكل؟",
  },
  LANGUAGE: {
    English: "إنجليزي",
    Persian: "فارسي",
  },
  language: {
    selectAll: "اختر الكل",
    lang: {
      fa: "الفارسية",
      ar: "العربية",
      ar_ae: "العربية (الإمارات)",
      ar_iq: "العربية (العراق)",
      en_US: "الإنجليزية (أمريكا)",
      en_GB: "الإنجليزية (بريطانيا)",
      de: "الألمانية",
      fr: "الفرنسية",
      zh_CN: "الصينية المبسطة",
      zh_TW: "الصينية التقليدية",
      tr: "التركية",
      ru: "الروسية",
      hy: "الأرمنية",
    },
    only_manual_now: "الحين بس الترجمة اليدوية موجودة",
    ai_coming_soon: "ترجمة الذكاء الاصطناعي بتشتغل قريب",
    got_it: "فهمت",
    origin_language: "اللغة الأصلية",
    target_languages: "اللغات المستهدفة",
    remove_all: "احذف كل اللغات",
    translation_method: "اختر طريقة الترجمة",
    manual_translation: "ترجمة يدوية",
    ai_translation: "ترجمة ذكاء اصطناعي",
    coming_soon: "قريب",
    source_language_updated: "اللغة الأصلية اتغيرت",
    error_changing_source_language: "صار خطأ بتغيير اللغة الأصلية",
    source_language_created: "لغة أصلية جديدة انخلقت",
    languages_saved: "اللغات الجديدة انحفظت",
    error_saving_languages: "صار خطأ بحفظ اللغات",
    error_loading_language: "صار خطأ بتحميل اللغة",
    languages_removed: "اللغات المحذوفة",
    new_languages_to_save: "لغات جديدة لازم تنحفظ",
    saved: "انحفظ",
    management_langs: "إدارة اللغات",
    add_langs: "أضف لغة",
    change_language: "غيّر اللغة",
    visit_card: "كرت الزيارة",
    translate_to: "ترجم لـ",
    main_language: "اللغة",
    no_languages_available: "ماكو لغات موجودة",
    return_to_default: "ارجع للغة الأصلية",
    translate: "ترجم",
    changes_pending: "جاري تطبيق التغييرات",
    apply_changes: "تطبيق التغييرات",
    cancel_changes: "إلغاء",
  },
  LISTS: {
    NoData: "ماكو شي",
    NoDataFound: "ما لقينا شي",
    NoDataFoundFor: "ما لقينا شي على {a}",
    NoPhoneNumber: "ماكو رقم",
    NoPostalCode: "ماكو رمز بريدي",
    AddANumber: "ضيف رقم",
    City: "المدينة",
    AddedBefore: "مضاف من قبل",
  },
  PAGES: {
    SendSms: "إرسال رسايل",
    MapSms: "إرسال بالخريطة",
    PhoneBook: "دفتر التلفون",
  },
  MONETARY: {
    Rial: "ريال",
  },
  HINTS: {
    SendMessageTitle:
      "العنوان بس اسم تختاره، تقدر تستخدم عناوين الرسايل القديمة عشان النص يتعبّى أوتوماتيك. العنوان ما يطلع بالرسالة، يستخدمونه بالتقارير والاقتراحات.",
    SendMessageTime:
      "وقت الإرسال هو وقت ما تدخل الرسالة قائمة الإرسال. انتبه، ما تطلع إلا بعد موافقة المدير.",
    CreatePhoneBook: "هالاسم يطلع لك لما تضيف أرقام من دفتر التلفون وانت ترسل.",
  },
  TOASTS: {
    SuccessCreate: "صار تمام إن شاء الله",
    FailedCreated: "ما صار",
    SuccessDelete: "تمسح",
    FailedDelete: "ما تمسح",
    SuccessEdit: "تعدل تمام",
    FailedEdit: "ما تعدّل",
    AddedSuccess: "ضاف",
    AddedFailed: "ما ضاف",
  },
  WALLET: {
    CustomCharge: "مبلغ على كيفك",
    GateWay: "بوابة الدفع",
    Price: "المبلغ",
    Details: [
      "٩٪ ضريبة بتضاف على المبلغ.",
      "تأكد من المبلغ زين، اللي تدفعه ما يرجع.",
    ],
    noGateWay: "ما عندك بوابة دفع.",
    PriceNotInRange: "المبلغ لازم يكون بين {min} و {max} ريال.",
    Pay: "ادفع",
    ErrorOnRedirectToGateWay: "صار خطأ وانت تروح لبوابة الدفع",
    ChargeWalletButtonDescription: "اضغط على + عشان تشحن حسابك",
  },
  login: {
    phoneField: {
      placeholderIran: "ابدأ بـ 9 (مثل +98 912 345 6789)",
      placeholderDefault: "دخل رقمك",
      maxDigitsError: "أكثر شي {count} أرقام!",
      iranMustStartWith9: "الجوال لازم يبدأ بـ 9 (مثل 912…)",
    },
    signup_button: "سجل يالله!",
    forget_password_title: "نسيت الباسوورد",
    register_title: "تسجيل مجاني",
    login_title: "دخول",
    back: "رجوع",
    username: "الجوال أو اسم المستخدم",
    otp_resend_button: "ارسل الكود مرة ثانية",
    password_label: "الباسوورد",
    password_hint: "على الأقل 8 حروف",
    name_label: "الاسم",
    name_rule: "على الأقل 3 حروف",
    lastname_label: "اللقب",
    phone_label: "الجوال",
    nid_label: "الرقم الوطني",
    parent_phone_label: "جوال المعرف (اختياري)",
    terms_and_conditions_message:
      "التسجيل يعني وافق على شروط ترمينال الإعلانات.",
    terms_and_conditions_link: "الشروط والأحكام",
    close: "سكّر",
    forgot_password_link: "نسيت الباسوورد؟",
    change_password: "غيّر الباسوورد",
    register_button: "تسجيل",
    login_button: "دخول",
    login_with_google: "دخول بجوجل",
    login_with_sms: "دخول برسالة",
    login_with_password: "دخول بباسوورد",
    already_registered: "مسجل من قبل؟",
    login_here: "ادخل هنا",
    no_account: "ما عندك حساب؟",
    signup_now: "سجل الحين!",
    more_info: "معلومات زيادة",
    text_login: "دخول",
    text_register: "تسجيل",
    required_field: "هذا الحقل لازم تملاه.",
    min_8_char: "قليل أقل من 8 حروف",
    required: "لازم تملاه",
    min_3_char: "على الأقل 3 حروف",
    max_50_char: "أكثر شي 50 حرف",
    no_internet: "ما عندك نت",
    no_phone_entered: "ما دخلت رقم",
    otp_sent_successfully: "الكود وصلك تمام",
    please_register_first: "سجل الأول يالله!",
    wait_3_min: "استنى 3 دقايق وبعدين جرب",
    login_successful: "دخلت تمام",
    internet_connection_error: "مشكلة بالنت!",
    agree_to_terms_error: "ما وافقت على الشروط!",
    otp_sent_successfully_register: "الكود وصل تمام",
    error: "خطأ",
    registration_nid_required_notice:
      "عشان الأمان ومنع الغش، لازم تدخل الرقم الوطني وانت تسجل بترمينال الإعلانات.",
  },
  home: {
    title: "الرئيسية",
    selectSystem: "اختار النظام",
    yourPoints: "نقاطك",
    discountCodes: "كودات الخصم",
    all: "الكل",
    discounts: "الخصومات",
    systemGuide: "دليل النظام",
    yourPointsDynamic: "نقاطك: {points}",
    confirm: "أكد",
    copy: "نسخ",
  },
  badges: {
    free: "مجاني",
    preRegister: "تسجيل مسبق",
    comingSoon: "بيجي قريب",
    testVersion: "نسخة تجريبية",
  },
  services: {
    qrLand: {
      title: "نظام كيو آر لاند",
      description: "صنع كيو آر ديناميكي",
      property: {
        0: "تشيّك واختيار نوع ومكان الإعلان",
        1: "تشيّك واختيار أنواع إعلانات السينما",
        2: "ما تحتاج تدفع عمولة ولا فلوس زيادة",
        3: "إدارة كل الإعلانات اللي في السينما بنفس الوقت",
      },
    },
    payamak: {
      title: "نظام بيامك لاند",
      description: "إرسال رسايل دعاية كثيرة مرة وحدة",
      property: {
        0: "إرسال رسايل كثيرة",
        1: "عنده بنك أرقام جديدة",
        2: "إرسال رسايل لنادي العملاء",
        3: "يقدر يتربط بكل المواقع والبرامج",
      },
    },
    robot: {
      title: "نظام روبوت لاند",
      description: "إدارة كل الأرقام والإعلانات واللوحات بنفس الوقت",
      property: {
        0: "نشر إعلانات جماعية وكثيرة",
        1: "إدارة الإعلانات بشكل ذكي وتدريجي",
        2: "إيجار وإضافة أرقام بدون حد",
        3: "تسجيل وإدارة كل الإعلانات مع بعض",
      },
    },
    infoLand: {
      title: "إنفو لاند",
      description: "أكثر من 2500 قاعدة بيانات مهن جديدة",
      property: {
        0: "فيه كل معلومات المهن",
        1: "مقسم حسب المدن والإمارات",
        2: "قاعدة بيانات وطنية لكل المهن",
        3: "تقدر تشوف عينات من كل القواعد",
      },
    },
    graphic: {
      title: "نظام جرافيك لاند",
      description: "من الصفر للمية تصميم جرافيك وفيديو",
      property: {
        0: "تصميم لوقو وأدوات إدارية",
        1: "كل خدمات الطباعة والتغليف",
        2: "تصميم كتالوج وبروشور وعلب",
        3: "تصميم وطباعة كل أنواع البانرات بجميع المقاسات",
      },
    },
    bestWebLand: {
      title: "نظام بست ويب لاند",
      description: "تصميم مواقع ودعمها وسيو",
      property: {
        0: "سيو المحتوى",
        1: "سيو خارج الصفحة",
        2: "سيو تقني",
        3: "سيو داخل الصفحة",
      },
    },
    onlineShop: {
      title: "منشئ المتجر الإلكتروني",
      description: "بس كم كلك وانت بالعالم الرقمي",
      badge: "بيع بالعمولة",
      property: {
        0: "سيو المحتوى",
        1: "سيو خارج الصفحة",
        2: "سيو تقني",
        3: "سيو داخل الصفحة",
      },
    },
    social: {
      title: "إعلانات السوشل ميديا",
      description: "تشيّك واختيار أحسن الصفحات والقنوات",
      property: {
        0: "تشيّك كل الصفحات اللي فيها زوار كثير",
        1: "إدارة كل الإعلانات مع بعض",
        2: "ما تحتاج تدفع عمولة ولا فلوس زيادة",
        3: "طلب إعلان أونلاين بالصفحات اللي تعجبك",
      },
    },
    billboard: {
      title: "إيجار لوحات إعلانية أونلاين",
      description: "بدون وسطاء وبتشيّك مستهدف للوحة",
      property: {
        0: "تشيّك مكان ونوع اللوحة",
        1: "إدارة كل اللوحات اللي عندنا",
        2: "تواصل مباشر مع صاحب اللوحة بدون وسطاء",
        3: "ما تحتاج تدفع عمولة ولا فلوس زيادة",
      },
    },
    internationalMedia: {
      title: "إعلانات الإعلام الوطني",
      description: "تشيّك ونشر إعلانات بالتلفزيون والراديو",
      property: {
        0: "تشيّك واختيار وقت بث الإعلان",
        1: "تشيّك واختيار أنواع إعلانات التلفزيون",
        2: "تشيّك واختيار أنواع إعلانات الراديو",
        3: "تشيّك واختيار إعلان حسب نوع البرنامج",
      },
    },
    transport: {
      title: "إعلانات أسطول النقل",
      description: "المطار، محطات القطار، البوبيسات والمترو",
      property: {
        0: "تشيّك واختيار نوع ومكان الإعلان",
        1: "تشيّك واختيار أنواع إعلانات المترو",
        2: "ما تحتاج تدفع عمولة ولا فلوس زيادة",
        3: "إدارة كل الإعلانات اللي في المترو مع بعض",
      },
    },
    cinema: {
      title: "إعلانات الوسائط المرئية",
      description: "نشر إعلانات بالسينما ومواقع الفيديو",
      property: {
        0: "تشيّك واختيار نوع ومكان الإعلان",
        1: "تشيّك واختيار أنواع إعلانات السينما",
        2: "ما تحتاج تدفع عمولة ولا فلوس زيادة",
        3: "إدارة كل الإعلانات اللي في السينما مع بعض",
      },
    },
    estate: {
      title: "نظام العقارات أونلاين",
      description: "إدارة الملفات والاستشاريين والعملاء",
      property: {
        0: "تشيّك واختيار نوع ومكان الإعلان",
        1: "تشيّك واختيار أنواع إعلانات السينما",
        2: "ما تحتاج تدفع عمولة ولا فلوس زيادة",
        3: "إدارة كل الإعلانات اللي في السينما مع بعض",
      },
    },
    AIGeneration: {
      title: "نظام الذكاء الاصطناعي",
      description: "صنع صور، شات بوت",
    },
    ShortLink: {
      title: "نظام الروابط القصيرة",
      description: "صنع رابط قصير",
    },
    customer: {
      title: "نظام إدارة العملاء أونلاين",
      description: "إدارة ودعم وخلق عملاء مخلصين",
      property: {
        0: "تشيّك واختيار نوع ومكان الإعلان",
        1: "تشيّك واختيار أنواع إعلانات السينما",
        2: "ما تحتاج تدفع عمولة وFq فلوس زيادة",
        3: "إدارة كل الإعلانات اللي في السينما مع بعض",
      },
    },
    internetBroadcasting: {
      title: "إدارة إعلانات الإنترنت",
      description: "إعلانات جوجل، إعلانات نقرة، ريبورتاج",
      property: {
        0: "تشيّك واختيار نوع ومكان الإعلان",
        1: "تشيّك واختيار أنواع إعلانات السينما",
        2: "ما تحتاج تدفع عمولة ولا فلوس زيادة",
        3: "إدارة كل الإعلانات اللي في السينما مع بعض",
      },
    },
    emailMarketing: {
      title: "نظام التسويق بالإيميل",
      description: "إرسال إيميل دعاية لكل المهن بالبلد",
      property: {
        0: "تشيّك واختيار نوع ومكان الإعلان",
        1: "تشيّك واختيار أنواع إعلانات السينما",
        2: "ما تحتاج تدفع عمولة ولا فلوس زيادة",
        3: "إدارة كل الإعلانات اللي في السينما مع بعض",
      },
    },
    adsOnStudium: {
      title: "إعلانات الملاعب والمعارض",
      description: "وجود براندك في أكبر المراكز",
      property: {
        0: "تشيّك واختيار نوع ومكان الإعلان",
        1: "تشيّك واختيار أنواع إعلانات السينما",
        2: "ما تحتاج تدفع عمولة ولا فلوس زيادة",
        3: "إدارة كل الإعلانات اللي في السينما مع بعض",
      },
    },
    bidOnline: {
      title: "نظام المزادات الشامل أونلاين",
      description: "حط مزاد أونلاين، اشترك بالمزادات",
      property: {
        0: "تشيّك واختيار نوع ومكان الإعلان",
        1: "تشيّك واختيار أنواع إعلانات السينما",
        2: "ما تحتاج تدفع عمولة ولا فلوس زيادة",
        3: "إدارة كل الإعلانات اللي في السينما مع بعض",
      },
    },
    onlineTools: {
      title: "نظام أدوات الأعمال أونلاين",
      description: "كل الأدوات المساعدة لأي نوع أعمال",
      property: {
        0: "تشيّك واختيار نوع ومكان الإعلان",
        1: "تشيّك واختيار أنواع إعلانات السينما",
        2: "ما تحتاج تدفع عمولة ولا فلوس زيادة",
        3: "إدارة كل الإعلانات اللي في السينما مع بعض",
      },
    },
    onlineLearn: {
      title: "نظام التعليم أونلاين للأعمال",
      description: "تشيّك واختيار دورات تدريبية مستهدفة",
      property: {
        0: "تشيّك واختيار نوع ومكان الإعلان",
        1: "تشيّك واختيار أنواع إعلانات السينما",
        2: "ما تحتاج تدفع عمولة ولا فلوس زيادة",
        3: "إدارة كل الإعلانات اللي في السينما مع بعض",
      },
    },
    cloud: {
      title: "الهوستينج وشراء الدومين",
      description: "شراء هوست، دومين وسيرفر",
      property: {
        0: "تشيّك واختيار نوع ومكان الإعلان",
        1: "تشيّك واختيار أنواع إعلانات السينما",
        2: "ما تحتاج تدفع عمولة ولا فلوس زيادة",
        3: "إدارة كل الإعلانات اللي في السينما مع بعض",
      },
    },
    QrlandShop: {
  title: "إدارة المتاجر الإلكترونية",
  description: "إدارة متكاملة للمنتجات والأسواق الإلكترونية والتسعير الذكي",
  property: {
    0: "مراقبة وإدارة شاملة للمنتجات",
    1: "إدارة خيارات المنتجات",
    2: "مراقبة الأسواق الإلكترونية وإدارتها",
    3: "استراتيجيات التسعير الذكي",
  },
},

  },
  "planning.title": "التخطيط",
  "tabs.reminder": "التذكير",
  "tabs.notes": "الملاحظات",
  "tabs.calendar": "التقويم",
  "notes.creationDate": "تاريخ الإنشاء",
  "common.save": "حفظ",
  "common.cancel": "إلغاء",
  "actions.quickActions": "إجراءات سريعة",
  "notes.writeMessage": "كتابة رسالة",
  "notes.titlePlaceholder": "عنوان الملاحظة",
  "notes.addNote": "إضافة ملاحظة",
  "notes.updatedSuccess": "تم تحديث الملاحظة بنجاح",
  "notes.addedSuccess": "تم إضافة الملاحظة بنجاح",
  "common.deletedSuccess": "تم الحذف بنجاح",
  "common.confirmDelete": "متأكد تبي تمسح؟",
  "news.title": "أخبار الموقع",
  "news.noNews": "ماكو أي خبر مسجل بالموقع",
  "news.view": "شوف",
  "remember.add": "إنشاء تذكير",
  "remember.update": "تحديث التذكير",
  "remember.titleLabel": "العنوان",
  "remember.dateLabel": "تاريخ التذكير",
  "remember.confirmDelete": "متأكد تبي تمسح؟",
  "remember.deleteSuccess": "تم حذف التذكير بنجاح",
  "remember.createSuccess": "تم إنشاء تذكير جديد",
  "remember.updateSuccess": "تم تحديث التذكير",
  "points.receivedAwards": "الجوائز اللي استلمته",
  "points.pointsHistory": "سجل النقاط",
  "points.points": "نقاط",
  "points.discountTitle": "خصم روبوت لاند",
  "points.discountText": "على كل ٥٠٠ نقطة",
  events: {
    title: "الفعاليات",
    addEvent: "إضافة فعالية",
    calendar: "التقويم الأساسي",
    close: "سكّر",
    save: "حفظ",
    update: "تحديث",
    confirmDelete: "متأكد تبي تمسح؟",
    successAdd: "تم الإضافة بنجاح",
    successDelete: "تم حذف الفعالية بنجاح",
    successUpdate: "تم التحديث بنجاح",
    titleLabel: "العنوان",
    descriptionLabel: "الوصف",
    colorLabel: "اللون",
    removeAfterDrop: "بعد الإسقاط",
    createEvent: "إنشاء فعالية",
  },
  copySuccess: "تم النسخ بنجاح",
  copyTextTitle: "نسخ",
  copiedTextTitle: "تم النسخ",
  ribbon: {
    new: "جديد",
  },
  coupons: [
    {
      text: "هالكوبون صالح 3 أسابيع",
      title: "نص غير متكرر 20%",
    },
    {
      text: "هالكوبون صالح أسبوعين",
      title: "تصميم موقع 5%",
    },
    {
      text: "هالكوبون يستخدم مرة وحدة بس",
      title: "إدارة الصفحة 10%",
    },
    {
      text: "هالكوبون مفعّل عندك بشكل دائم",
      title: "تصميم جرافيك 5%",
    },
    {
      text: "هالكوبون يستخدم مرة وحدة",
      title: "طباعة 2%",
    },
  ],
  userLinks: {
    profile: {
      title: "نظرة عامة",
      invitation: { title: "دعوة الأصدقاء" },
      info: { title: "المعلومات الشخصية" },
      edit: { title: "استكمال البروفايل" },
      changePass: { title: "تغيير كلمة المرور" },
    },
  },
  profileLinks: {
    orders: "الطلبات",
    addresses: "العناوين",
  },
  customPage: {
    overview: "نظرة عامة",
    personalInfo: "المعلومات الشخصية",
    changePassword: "تغيير كلمة المرور",
    completeProfile: "استكمال البروفايل",
    email: "الإيميل",
    balance: "الرصيد",
    phone: "رقم الجوال",
    rial: "ريال",
  },
  widget12: {
    inviteFriends: "دعوة الأصدقاء",
    viewInvitedUsers: "شوف قائمة الناس اللي دعيتهم",
    yourInviteCode: "كود دعوتك",
    createNewUser: "إنشاء مستخدم جديد",
    copyText: "نسخ",
    userCreatedSuccess: "تم إنشاء المستخدم الجديد بنجاح",
    notCreated: "ما انخلق",
  },
  userInfo: {
    userInformation: "معلومات المستخدم",
    profilePicture: "صورة البروفايل",
    allowedFileTypes: "الملفات المسموحة: png، jpg، jpeg",
    profilePictureSize: "صورة البروفايل لازم تكون مقاس موحد (مثل ٤٨٠×٤٨٠)",
    firstName: "الاسم",
    lastName: "اللقب",
    username: "اسم المستخدم",
    phone: "رقم الجوال",
    email: "الإيميل",
    receiveSMS: "استقبال الرسايل",
    smsCostNote: "لو فعّلت هالخيار، تكلفة الرسايل بتتخصم من رصيدك",
    saveChanges: "حفظ التغييرات",
    profileUpdated: "تم تحديث البروفايل بنجاح",
  },
  emailSettings: {
    completeProfile: "استكمال البروفايل",
    completeProfileDesc: "استكمال معلومات الشخص أو الشركة",
    cancel: "إلغاء",
    update: "تحديث",
    save: "حفظ",
    selectPersonType: "اختار نوع الشخص؟",
    realPerson: "شخص طبيعي",
    legalPerson: "شخص اعتبارى (شركة)",
    phone: "رقم الجوال",
    landline: "رقم الأرضي",
    fatherName: "اسم الأب",
    nationalCode: "الرقم الوطني",
    idNumber: "رقم الهوية",
    birthday: "تاريخ الميلاد",
    placeOfBirth: "مكان الولادة",
    postalCode: "الرمز البريدي",
    email: "الإيميل",
    introduction: "شلون عرفت علينا",
    nationalCodePic: "صورة البطاقة الوطنية",
    plaque: "رقم اللوحة",
    address: "العنوان كامل",
    companyName: "اسم الشركة/المحل",
    registrationNumber: "رقم التسجيل",
    economicCode: "الكود الاقتصادي",
    organizationIdentity: "الرقم الوطني للشركة",
    companyType: "نوع الشركة",
    activity: "مجال النشاط",
    registrationAd: "صورة إعلان تسجيل الشركة",
    lastPublishedAd: "صورة آخر إعلان رسمي",
    statute: "صورة النظام الأساسي",
    agentLetterPic: "صورة خطاب تعيين الوكيل",
    successMessage: "تم التسجيل بنجاح",
    errorSelectType: "اختار واحد يالله",
    rules: {
      companyName: "حقل اسم الشركة أو المحل لازم تملاه",
      registrationNumber: "رقم التسجيل لازم",
      economicCode: "الكود الاقتصادي لازم",
      organizationIdentity: "الرقم الوطني للشركة لازم",
      registrationAd: "صورة إعلان التسجيل لازم",
      lastPublishedAd: "صورة آخر إعلان لازم",
      telephone: "رقم الأرضي لازم",
      fatherName: "اسم الأب لازم",
      nationalCode: "الرقم الوطني لازم",
      birthday: "تاريخ الميلاد لازم",
      idNumber: "رقم الهوية لازم",
      placeOfBirth: "مكان الولادة لازم",
      postalCode: "الرمز البريدي لازم",
      nationalCodePic: "صورة البطاقة لازم",
      address: "العنوان لازم",
      plaque: "رقم اللوحة لازم",
    },
    companyTypes: {
      governmental: "حكومي",
      private: "خاص",
      commonStock: "مساهمة عامة",
      specialStock: "مساهمة خاصة",
    },
  },
  changePassword: {
    title: "تغيير كلمة المرور",
    description: "غيّر كلمة مرور حسابك",
    cancel: "إلغاء",
    update: "تحديث",
    passwordInstructions: {
      forgotPassword: "لو ما حطيت باسوورد من قبل، اضغط نسيت كلمة المرور",
      passwordRequirements:
        "الباسوورد لازم 8 حروف على الأقل فيها أرقام وحروف كبيرة وصغيرة ورموز",
      passwordPrivacy: "لا تعطي باسووردك لحد",
      keyboardLanguage: "تأكد إن الكيبورد إنجليزي وانت تكتب الباسوورد",
    },
    currentPassword: "الباسوورد الحالي",
    newPassword: "الباسوورد الجديد",
    confirmNewPassword: "تأكيد الباسوورد الجديد",
    addOrForgotPassword: "إضافة أو نسيان الباسوورد",
    changePasswordWithCode: "تغيير الباسوورد بالجوال",
    close: "سكّر",
    change: "غيّر",
    enterCode: "دخل الكود",
    successMessage: "تم تغيير الباسوورد بنجاح",
    invalidCode: "الكود غلط",
    tooManyAttempts: "جرب كثير! انتظر شوي",
    rules: {
      required: "هالحقل لازم",
      min: "الباسوورد أقل من 8 حروف",
      equal: "الباسوورد الجديد ما يطابق التأكيد",
      number: "دخل رقم الجوال",
    },
  },
  router: {
    dashboard: "الداشبورد",
    contacts: "نادي العملاء",
    editContact: "تعديل العميل",
    createContact: "إنشاء عميل",
    customers: "قائمة العملاء",
    contactList: "مساعد الاتصال",
    messages: "الرسايل",
    messageCategories: "تصنيفات الرسايل",
    oldTransactions: "المعاملات القديمة",
    yourTransactions: "معاملاتك",
    buyPanel: "شراء لوحة",
    permissions: "الصلاحيات",
    createPermission: "إنشاء صلاحية",
    invitations: "قائمة مدعويني",
    editUser: "تعديل المستخدم",
    userInformation: "معلومات المستخدم",
    walletEdit: "تعديل محفظة المستخدم",
    userHistory: "سجل المستخدم",
    userNotificationsHistory: "سجل التنبيهات",
    notifications: "التنبيهات",
    createNotification: "إنشاء تنبيه",
    editNotification: "تعديل التنبيه",
    adminNotifications: "تنبيهات الإدارة",
    yourNotifications: "تنبيهاتك",
    adminNotificationsList: "تنبيهات المدير",
    tickets: "التذاكر",
    createTicket: "تسجيل تذكرة جديدة",
    editTicket: "تعديل التذكرة",
    departments: "الأقسام",
    createDepartment: "قسم جديد",
    editDepartment: "تعديل القسم",
    adminTickets: "إدارة التذاكر",
    discounts: "الخصومات",
    createDiscount: "إنشاء خصم",
    editDiscount: "تعديل الخصم",
    workReports: "تقارير العمل",
    createWorkReport: "إنشاء تقرير عمل",
    callMonitoring: "مراقبة المكالمات",
    adminWorkReports: "إدارة تقارير العمل",
    editWorkReport: "عرض وتعديل تقرير العمل",
    packProperties: "خصائص الباقة",
    createPackProperty: "إنشاء خاصية باقة",
    editPackProperty: "تعديل خاصية الباقة",
    panels: "اللوحات",
    createPanel: "إنشاء لوحة",
    editPanel: "تعديل اللوحة",
    transferRequests: "طلبات السحب",
    editTransferRequest: "تعديل طلب السحب",
    tariffs: "التعرفة",
    createTariff: "إنشاء تعرفة",
    editTariff: "تعديل التعرفة",
    requests: "الطلبات",
    viewUser: "عرض المستخدم",
    manageTransactions: "إدارة المعاملات",
    viewTransaction: "عرض المعاملة",
    manageConfigs: "إدارة الإعدادات",
    rbLandConfigs: "إعدادات روبوت لاند",
    editConfig: "تعديل الإعدادات",
    manageUsers: "إدارة المستخدمين",
    categories: "التصنيفات",
    createCategory: "إضافة تصنيف",
    editCategory: "تعديل التصنيف",
    content: "المحتوى",
    createContent: "إضافة محتوى",
    editContent: "تعديل المحتوى",
    addUserGuide: "إضافة دليل المستخدم",
    editUserGuide: "تعديل دليل المستخدم",
    roles: "الأدوار",
    editRole: "تعديل الدور",
    createRole: "إضافة دور",
    permissionTitle: "الصلاحيات",
    paymentGateways: "بوابات الدفع",
    editPaymentGateway: "تعديل بوابة الدفع",
    campaigns: "الحملات",
    createCampaign: "إنشاء حملة",
    editCampaign: "تعديل الحملة",
    adminCustomers: "العملاء",
    createCustomer: "إنشاء عميل",
    editCustomerInfo: "تعديل معلومات العميل",
    referrerCustomers: "العملاء المعرفين",
    customerHistory: "سجل العميل",
    userProfile: "البروفايل",
    editProfile: "تعديل البروفايل",
    inviteFriends: "دعوة الأصدقاء",
    personalInfo: "المعلومات الشخصية",
    editPersonalInfo: "تعديل المعلومات",
    changePassword: "تغيير كلمة المرور",
    newWallet: "محفظة جديدة",
  },
  profileView: {
    email: "الإيميل",
    balance: "الرصيد",
    personType: "نوع الشخص",
    currency: "ريال",
    unknown: "----",
  },
  panelInfoProfile: {
    panelTitle: "عندك لوحة {title} صالحة لـ {days} يوم",
    buyOrRenew: "عشان تشتري أو تجدد لوحتك اضغط الزر تحت",
    buyPanel: "شراء لوحة",
    percentage: "%",
  },
  profileSetting: {
    cardTitle: "إعدادات البروفايل",
    changePasswordTitle: "تغيير كلمة المرور",
    changePasswordSubtitle: "غيّر كلمة مرور حسابك",
    alertMessage: "لو ما سجلت باسوورد من قبل، فعّل خيار تسجيل كلمة المرور",
    currentPasswordLabel: "كلمة المرور الحالية",
    setPasswordLabel: "تسجيل كلمة المرور",
    addPassword: "إضافة كلمة مرور",
    newPasswordLabel: "كلمة المرور الجديدة",
    repeatPasswordLabel: "تأكيد كلمة المرور",
    saveChanges: "ح5ظ التغييرات",
    currentPasswordPlaceholder: "كلمة المرور الحالية",
    newPasswordPlaceholder: "كلمة المرور الجديدة",
    repeatPasswordPlaceholder: "تأكيد كلمة المرور",
  },
  profileOrders: {
    cardTitle: "الطلبات",
    openOrders: "الطلبات المفتوحة ({count})",
    closedOrders: "الطلبات المقفلة ({count})",
    noOrders: "للحين ما عندك أي طلب",
  },
  personalInformation: {
    cardTitle: "معلومات الحساب الشخصي",
    cardSubtitle: "حدّث معلوماتك الشخصية",
    cancel: "إلغاء",
    update: "تحديث",
    yourInfo: "معلوماتك",
    profilePicture: "صورة البروفايل",
    allowedFileTypes: "الملفات المسموحة: png، jpg، jpeg",
    pictureSize: "صورة البروفايل لازم تكون مقاس موحد (مثل ٤٨٠×٤٨٠)",
    name: "الاسم",
    lastName: "اللقب",
    username: "اسم المستخدم",
    receiveSMS: "استقبال الرسايل",
    smsCostNote: "لو فعّلت هالخيار، تكلفة الرسايل بتتخصم من رصيدك",
    phoneNumber: "رقم الجوال",
    phonePlaceholder: "رقم الجوال",
    email: "الإيميل",
    emailPlaceholder: "الإيميل",
    emailPrivacy: "أكيد ما بنعطي إيميلك لحد",
    successMessage: "تم تحديث البروفايل بنجاح",
  },
  userInfoForm: {
    companyName: "اسم الشركة/المحل",
    registrationNumber: "رقم التسجيل",
    economicCode: "الكود الاقتصادي",
    organizationIdentity: "الرقم الوطني للشركة",
    companyType: "نوع الشركة",
    activity: "مجال النشاط",
    registrationAd: "صورة إعلان تسجيل الشركة",
    lastPublishedAd: "صورة آخر إعلان رسمي",
    statute: "صورة النظام الأساسي",
    argentLetterPic: "صورة خطاب تعيين الوكيل",
    phone: "رقم الجوال",
    telephone: "رقم الأرضي",
    fatherName: "اسم الأب",
    nationalCode: "الرقم الوطني",
    id: "رقم الهوية",
    birthday: "تاريخ الميلاد",
    placeBirthday: "مكان الولادة",
    postalCode: "الرمز البريدي",
    email: "الإيميل",
    introduction: "شلون عرفت علينا",
    nationalCodePic: "صورة البطاقة الوطنية",
    plaque: "رقم اللوحة",
    address: "العنوان كامل",
    companyTypes: {
      governmental: "حكومي",
      private: "خاص",
      common_stock: "مساهمة عامة",
      special_stock: "مساهمة خاصة",
    },
    rules: {
      companyName: "حقل اسم الشركة أو المحل لازم",
      registration_number: "رقم التسجيل لازم",
      economic_code: "الكود الاقتصادي لازم",
      organization_identity: "الرقم الوطني للشركة لازم",
      registration_ad: "صورة إعلان التسجيل لازم",
      last_published_ad: "صورة آخر إعلان لازم",
      telephone: "رقم الأرضي لازم",
      fatherName: "اسم الأب لازم",
      nationalCode: "الرقم الوطني لازم",
      id: "رقم الهوية لازم",
      birthday: "تاريخ الميلاد لازم",
      placeBirthday: "مكان الولادة لازم",
      postalCode: "الرمز البريدي لازم",
      nationalCodePic: "صورة البطاقة لازم",
      address: "العنوان لازم",
      plaque: "رقم اللوحة لازم",
    },
  },
  createUserForm: {
    name: "الاسم",
    lastName: "اللقب",
    nid: "الرقم الوطني",
    phone: "رقم الجوال",
    create: "إنشاء",
    errors: {
      nameRequired: "الاسم ما دخلته!",
      lastNameRequired: "اللقب ما دخلته!",
      nidRequired: "الرقم الوطني ما دخلته!",
      phoneRequired: "رقم الجوال ما دخلته!",
    },
  },
  lastView: {
    cardTitle: "آخر زياراتك",
    cardSubtitle: "آخر الصفحات اللي دخلتها",
    tableHeaders: {
      page: "الصفحة",
      address: "العنوان",
      enterDate: "تاريخ الدخول",
      leaveDate: "تاريخ الخروج",
      timeSpent: "الوقت اللي قضيته",
    },
    viewAll: "شوف الكل",
    timeUnit: "دقيقة",
    pages: {
      home: "الرئيسية",
      panels: "اللوحات",
      profile: "استكمال البروفايل",
    },
  },
walletWidget: {
  title: "المعاملات الأخيرة",
  balanceLabel: "رصيدك:",
  viewTransactions: "عرض المعاملات",
  transactionTypes: {
    withdraw: "سحب",
    deposit: "إيداع",
    charge: "شحن المحفظة",
    refund: "استرداد",
    default: "معاملة",
    adminCharge: "تعديل بواسطة المسؤول",
    agency: "عمولة الوكالة",
  },
},
  panelWidget: {
    title: "عندك لوحة {title} صالحة لـ {days} يوم",
    renewPrompt: "عشان تشتري أو تجدد اضغط الزر تحت",
    buyPanel: "شراء لوحة",
    percentage: "{value}%",
    infinity: "∞",
    days: "{count} يوم",
  },
  component: {
    title: "الناس اللي دعيتهم",
    columns: {
      row: "الرقم",
      name: "الاسم",
      family: "اللقب",
      username: "اسم المستخدم",
      phone: "رقم الجوال",
      created_at: "تاريخ الانضمام",
      actions: "الإجراءات",
    },
    unknown: "ما نعرف",
    error: "خطأ",
    breadcrumb: "الناس اللي دعيتهم",
  },
  table: {
    itemsPerPage: "عدد الصفوف بالصفحة",
    pageText: "من {0} إلى {1} من {2}",
    prevText: "اللي قبل",
    nextText: "اللي بعد",
    noDataText: "ماكو شي",
    search: "دور",
  },
  UserHistory: {
    title: "سجل المستخدمين",
    add_history: "تسجيل جديد",
    send_message: "إرسال رسالة",
    close: "سكّر",
    save: "حفظ",
    cancel: "إلغاء",
    new_history_dialog_title: "تسجيل سجل جديد",
    send_message_dialog_title: "إرسال رسالة",
    negotiations: "التفاوض اللي صار",
    follow_up: "اللي لازم نتابعه بالمكالمة الجاية",
    success_history: "تم حفظ السجل بنجاح",
    success_message: "الرسالة طلعت بنجاح",
    columns: {
      id: "الرقم",
      title: "العنوان",
      status: "المرحلة",
      current_time_date: "تاريخ آخر مكالمة",
      current_time_hour: "ساعة آخر مكالمة",
      next_time_date: "تاريخ المكالمة الجاية",
      next_time_hour: "ساعة المكالمة الجاية",
      user_id: "الدعم",
      actions: "الإجراءات",
    },
    table: {
      itemsPerPage: "عدد الصفوف بالصفحة",
      pageText: "من {0} إلى {1} من {2}",
      prevText: "اللي قبل",
      nextText: "اللي بعد",
      noDataText: "ماكو شي",
      search: "دور",
    },
    form: {
      title: "العنوان",
      status: "المرحلة",
      current_time: "تاريخ آخر مكالمة",
      description: "التفاصيل",
      next_time: "تاريخ المكالمة الجاية",
      pursue_text: "متابعة المكالمة الجاية",
      category: "اختار التصنيف",
      message_title: "عنوان الرسالة",
    },
  },
  newUserTransactions: {
    userWallet: "محفظة المستخدم",
    transactionList: "قائمة المعاملات",
    userTransactions: "معاملات المستخدم",
    terminal: "الترمينال",
    liveSms: "رسايل حية",
    realEstateNews: "آخر أخبار الديوان",
    rial: "ريال",
    row: "الرقم",
    uniqueId: "المعرف",
    amount: "المبلغ",
    time: "الساعة",
    createdAt: "التاريخ",
    description: "تفاصيل زيادة",
    type: "نوع المعاملة",
    product_description: "الوصف",
    serviceId: "اسم الخدمة",
    balanceAfter: "الرصيد بعدين",
    perPage: "العدد",
    search: "دور",
    balance: "الرصيد",
    transactionListTooltip: "قائمة المعاملات",
    panelLogin: "دخول اللوحة",
    history: "السجل",
    error: {
      terminalWallet: "خطأ بجلب محفظة الترمينال",
    },
    transactionType: "نوع المعاملة",
    service: "الخدمة",
    dateFrom: "من تاريخ",
    dateTo: "لحد تاريخ",
    oldWallet: "المحفظة القديمة",
    depositReceipt: "وصل الإيداع",
    showReceipt: "ورّيني الوصل",
    transactionTypes: {
      online: "أونلاين",
      admin: "من الإدارة",
      refund: "تصحيحية",
      agency: "وكالة",
      withdraw: "سحب",
      deposit: "إيداع",
      adminCharge: "معاملة من الإدارة",
      charge: "شحن المحفظة",
      refund: "استرجاع",
    },
    error: {
      imageLoad: "خطأ بتحميل الصورة!",
    },
  },
  buyPanel: {
    alert: {
      choosePanel: "انتبه زين وانت تختار نوع اللوحة!",
    },
    dialog: {
      title: "شراء لوحة",
      confirmPurchase: "متأكد تبي تشتري لوحة {title}؟",
      discountCodeLabel: "كود الخصم",
      discountCodePlaceholder: "دخل كود الخصم اللي عندك",
      applyDiscount: "تسجيل الكود",
      purchase: "اشتري",
      iHaveDiscount: "عندي كود خصم",
    },
    toast: {
      discountApplied: "كود الخصم انطبق تمام!",
      purchaseSuccess: "تم شراء الباقة بنجاح",
      error: "صار خطأ: {message}",
      unauthorized: "ادخل أول شي",
      validationError: "خطأ بالتحقق: {message}",
    },
    currency: "ريال",
  },
  panelCard: {
    rial: "ريال",
    days: "يوم",
    buyPanel: "شراء لوحة",
  },
  cons: {
    title: "اختار إيموجي",
  },
  cons1: {
    title: "نص افتراضي",
  },
  MENUS: {
    AD_TERMINAL_SYSTEM: "منظومة ترمينال الإعلانات الجامبو",
  },
};
